// App.js
import React from 'react';
import Bifrost from './pages/bifrost';

const App = () => {
  return <Bifrost />;
};

export default App;
